import { render, staticRenderFns } from "./FilterSidebarCategoriesItem.vue?vue&type=template&id=4eca18e6&scoped=true&"
import script from "./FilterSidebarCategoriesItem.vue?vue&type=script&lang=js&"
export * from "./FilterSidebarCategoriesItem.vue?vue&type=script&lang=js&"
import style0 from "./FilterSidebarCategoriesItem.vue?vue&type=style&index=0&id=4eca18e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eca18e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eca18e6')) {
      api.createRecord('4eca18e6', component.options)
    } else {
      api.reload('4eca18e6', component.options)
    }
    module.hot.accept("./FilterSidebarCategoriesItem.vue?vue&type=template&id=4eca18e6&scoped=true&", function () {
      api.rerender('4eca18e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarCategoriesItem.vue"
export default component.exports